import(/* webpackMode: "eager" */ "/app/src/app/(legal)/security/page.tsx");
